import { useEffect, useState } from "react";
import Header from "./Header";
import Right from "./Right";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllMemberships } from "../../redux/membershipSlice";
import { toast } from "react-toastify";
import { server } from "../../server";
import { getUserIdFromToken } from "../../utils/auth";
import { useNavigate } from "react-router-dom";

function Upgrade() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { allMemberships, loading } = useSelector((state) => state.membership);
  const [payingId, setPayingId] = useState(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    if (!allMemberships || allMemberships.length === 0) {
      dispatch(fetchAllMemberships());
    }
  }, [dispatch, allMemberships.length]);

  const handlePayment = async (membershipId) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        toast.error("Please login again");
        return;
      }

      const userId = getUserIdFromToken();
      if (!userId) {
        toast.error("Invalid session, please login again");
        return;
      }

      setPayingId(membershipId);

      const orderRes = await fetch(`${server}/BuyMembership/CreateOrder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          userId,
          membershipId,
        }),
      });

      const orderData = await orderRes.json();

      if (!orderData?.order?.id) {
        toast.error("Failed to create order");
        setPayingId(null);
        return;
      }

      const options = {
        key: "rzp_live_7tDFFTUgWahyM5",
        amount: orderData.order.amount,
        currency: orderData.order.currency,
        name: "GoRishtey",
        description: "Membership Payment",
        image: "https://matrimony12.s3.ap-south-1.amazonaws.com/MyLogo.jpg",
        order_id: orderData.order.id,

        handler: async function (response) {
          try {
            const verifyRes = await fetch(
              `${server}/BuyMembership/ConfirmPayment`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: token,
                },
                body: JSON.stringify({
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_signature: response.razorpay_signature,
                  userId,
                  membershipId,
                }),
              }
            );

            const verify = await verifyRes.json();
            setPayingId(null);

            if (verify?.message?.toLowerCase().includes("verified")) {
              toast.success("Payment Successful 🎉");
              navigate("/matches");
            } else {
              toast.error("Payment Verification Failed");
            }
          } catch {
            setPayingId(null);
            toast.error("Payment Verification Failed");
          }
        },

        modal: {
          ondismiss: () => {
            setPayingId(null);
            toast.info("Payment Cancelled");
          },
        },

        theme: { color: "#ff5a60" },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

      rzp.on("payment.failed", () => {
        setPayingId(null);
        toast.error("Payment Failed");
      });
    } catch (err) {
      setPayingId(null);
      toast.error("Payment Failed");
    }
  };

  return (
    <>
      <Header />

      <section>
        <div className="container pt-3">
          <div className="row g-3">
            <div className="col-lg-8 col-12 mb-5">
              <div>
                <h3 className="fw-medium ls-sm text-dark lh-1 fs-4 m-0">
                  Upgrade Membership
                </h3>
                <p className="lh-sm fw-normal m-0">
                  Go premium for Full Access on GoRishtey.Com
                </p>
              </div>
              <div className="mt-3 position-relative d-flex align-items-center">
                <div className="bg-light-success py-3 rounded-4 d-flex align-items-center px-5 w-100">
                  <img
                    src="/assets/images/secure.png"
                    width="40"
                    alt="secure"
                  />
                  <div className="ms-3">
                    <h5 className="m-0 lh-1">
                      The safest, smartest & most secure matrimony platform in
                      India
                    </h5>
                    <p className="m-0 lh-1 mt-1">
                      Your transactions are protected with industry-standard
                      encryption.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-3">
                <div className="row g-2">
                  {loading && (
                    <div className="d-flex flex-column justify-content-center align-items-center">
                      <div
                        class="spinner-border text-red-primary mt-4"
                        role="status"
                      ></div>
                    </div>
                  )}

                  {!loading &&
                    allMemberships?.map((item) => (
                      <div className="col-lg-6 col-12" key={item._id}>
                        <div className="p-5 rounded-4 shadow bg-white h-100">
                          {/* Plan Title */}
                          <p className="m-0 text-dark fw-medium text-center lh-1">
                            {item.plan}
                            <span className="text-secondary ms-1">
                              {item.durationTitle}
                            </span>
                          </p>

                          {/* Discount */}
                          {item.discountPercent && (
                            <p className="m-0 text-success text-center">
                              {item.discountPercent}% OFF
                              <del className="text-secondary ms-1">
                                ₹{item.actualPrice}
                              </del>
                            </p>
                          )}

                          <h2 className="text-center mt-2">
                            ₹{item.offerPrice}
                          </h2>
                          <div className="text-center">
                            <span className="badge bg-danger ms-2 px-3 rounded-pill fw-normal fs-6">
                              {item.category} Plan
                            </span>
                          </div>
                          <p className="m-0 text-dark lh-1 mt-3 text-center">
                            {item.planDescription}
                          </p>
                          <div className="mt-3 d-flex flex-wrap gap-1 justify-content-center">
                            <span className="badge border border-light text-dark px-3 rounded-pill fw-normal fs-6">
                              Send {item.sendRequestLimit} Requests
                            </span>

                            <span className="badge border border-light text-dark px-3 rounded-pill fw-normal fs-6">
                              Unlock {item.profileUnlockLimit} Profiles
                            </span>

                            <span className="badge border border-light text-dark px-3 rounded-pill fw-normal fs-6">
                              Visit {item.profileVisitLimit} Profiles
                            </span>

                            {item.dedicatedSupport && (
                              <span className="badge border border-light text-dark px-3 rounded-pill fw-normal fs-6">
                                Dedicated Support
                              </span>
                            )}

                            {item.crownBadgeProfile && (
                              <span className="badge border border-light text-dark px-3 rounded-pill fw-normal fs-6">
                                Crown Badge Profile
                              </span>
                            )}
                          </div>

                          <div className="d-flex justify-content-center">
                            <button
                              className="btn btn-dark rounded-pill mt-4 px-5 fw-normal"
                              onClick={() => handlePayment(item._id)}
                            >
                              {payingId === item._id
                                ? "Opening Payment Gateway"
                                : "Continue"}
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>

            <Right />
          </div>
        </div>
      </section>
    </>
  );
}

export default Upgrade;
